/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { subtleLink } from './mixins';

export const CenteredRow = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
});

export const CenteredColumn = styled(CenteredRow)({
  flexDirection: 'column',
});

// width: 0 set due to browser bug with nested flex containers
// see: https://stackoverflow.com/a/34355447
export const CodeBlock = styled.code({
  color: token('color.text', colors.N800),
  flex: 1,
  fontFamily: token('font.family.code'),
  fontSize: '12px',
  overflowX: 'auto',
  whiteSpace: 'pre-wrap',
  width: 0,
});

export const CodeContainer = styled.div({
  alignItems: 'center',
  background: token('elevation.surface.sunken', colors.N20),
  display: 'flex',
  marginTop: token('space.100'),
  padding: token('space.100'),
});

export const SubtleLink = styled.a(subtleLink);

export const HorizontalRule = styled.hr({
  background: token('color.border', colors.N40),
  border: 0,
  height: '2px',
});

export const IconWithCountWrapper = styled.span({
  alignItems: 'center',
  display: 'flex',
  '& + &': {
    marginLeft: token('space.200'),
  },
});

export const IconWithCountIconWrapper = styled.span({
  alignItems: 'center',
  display: 'flex',
  marginRight: token('space.050'),
});

// For label styles when you are not associating an HTML <label> with a form field
// @ts-ignore Styled components types are out of date, doesn't accept a string for font weight
export const FakeLabel = styled.span({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  display: 'block',
  marginBottom: token('space.050'),
});

export const ProcessingMessage = styled.div({
  marginLeft: 'auto',
  marginRight: token('space.100'),
});

export const Divider = styled.hr({
  height: '1px',
  border: 0,
  backgroundColor: token('color.border', colors.N30A),
  margin: `${token('space.100', '8px')} 0`,
});
